import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import bootstrap from './bootstrap'
import CardsComponent from './components/CardsComponent.vue'
import NavBarComponent from './components/NavBarComponent.vue'
import CardsPlansComponent from './components/CardsPlansComponent.vue'
import NavBarTermComponent from './components/NavBarTerm.vue'
import FooterTallosInformations from './components/FooterTallosInformations.vue'
import ModalConfirmProposal from './components/Modal/ModalConfirmProposal.vue'
import ModalAlertDefault from './components/Modal/ModalAlertDefault.vue'

createApp(App)
.use(bootstrap)
.use(store)
.use(router)
.component('cards-component', CardsComponent)
.component('nav-bar-component', NavBarComponent)
.component('nav-bar-term-component', NavBarTermComponent)
.component('footer-tallos-informations', FooterTallosInformations)
.component('cards-plans-component', CardsPlansComponent)
.component('modal-proposal-accepted', ModalConfirmProposal)
.component('modal-alert-default', ModalAlertDefault)
.mount('#app')
